import request from '@/utils/request'
import qs from 'qs'


export const mediationTop = () => {
    return request({
        url: '/api/mediation/top',
        method: 'GET'
    })
}

export const mediationRight = params => {
    return request({
        url: '/api/mediation/right',
        method: 'GET',
        params
    })
}

export const mediationBottom = params => {
    return request({
        url: '/api/mediation/bottom',
        method: 'GET',
        params
    })
}

export const enterpriseTop = () => {
    return request({
        url: '/api/enterprise/top',
        method: 'GET'
    })
  }
  
export const enterpriseRight = params => {
    return request({
        url: '/api/enterprise/right',
        method: 'GET',
        params
    })
}
  
  export const enterpriseBottom = params => {
    return request({
        url: '/api/enterprise/bottom',
        method: 'GET',
        params
    })
  }

export const enterpriseRightBot = params => {
    return request({
        url: '/api/enterprise/datarange',
        method: 'GET',
        params
    })
}

// 获取身份过期信息
export const getPersonInfo = () => {
    return request({
        url: '/api/dept/info',
        method: 'GET',
    })
}